import { useLanguage } from "@/components/language-provider";

/** Document/signer status pill: coloured dot + translated label, one look everywhere. */
const STYLES: Record<string, string> = {
  completed: "bg-emerald-50 text-emerald-800 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-900",
  signed: "bg-emerald-50 text-emerald-800 border-emerald-200 dark:bg-emerald-950/40 dark:text-emerald-300 dark:border-emerald-900",
  pending: "bg-amber-50 text-amber-800 border-amber-200 dark:bg-amber-950/40 dark:text-amber-300 dark:border-amber-900",
  sent: "bg-sky-50 text-sky-800 border-sky-200 dark:bg-sky-950/40 dark:text-sky-300 dark:border-sky-900",
  in_progress: "bg-sky-50 text-sky-800 border-sky-200 dark:bg-sky-950/40 dark:text-sky-300 dark:border-sky-900",
  viewed: "bg-indigo-50 text-indigo-800 border-indigo-200 dark:bg-indigo-950/40 dark:text-indigo-300 dark:border-indigo-900",
  draft: "bg-slate-50 text-slate-700 border-slate-200 dark:bg-slate-900/60 dark:text-slate-300 dark:border-slate-800",
  cancelled: "bg-rose-50 text-rose-800 border-rose-200 dark:bg-rose-950/40 dark:text-rose-300 dark:border-rose-900",
  declined: "bg-rose-50 text-rose-800 border-rose-200 dark:bg-rose-950/40 dark:text-rose-300 dark:border-rose-900",
  expired: "bg-slate-100 text-slate-600 border-slate-200 dark:bg-slate-900/60 dark:text-slate-400 dark:border-slate-800",
  imported: "bg-violet-50 text-violet-800 border-violet-200 dark:bg-violet-950/40 dark:text-violet-300 dark:border-violet-900",
};
const DOTS: Record<string, string> = {
  completed: "bg-emerald-500", signed: "bg-emerald-500", pending: "bg-amber-500", sent: "bg-sky-500", in_progress: "bg-sky-500",
  viewed: "bg-indigo-500", draft: "bg-slate-400", cancelled: "bg-rose-500", declined: "bg-rose-500", expired: "bg-slate-400",
  imported: "bg-violet-500",
};

export function StatusBadge({ status, className = "" }: { status: string; className?: string }) {
  const { t } = useLanguage();
  const key = (status || "").toLowerCase();
  const label = t(`status.${key}`) === `status.${key}` ? key.replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase()) : t(`status.${key}`);
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap ${STYLES[key] || STYLES.draft} ${className}`} data-testid={`status-${key}`}>
      <span className={`h-1.5 w-1.5 rounded-full ${DOTS[key] || DOTS.draft}`} />
      {label}
    </span>
  );
}
